import { render } from "./ModalVisualizarDespesaProjeto.vue?vue&type=template&id=05487fb2&scoped=true"
import script from "./ModalVisualizarDespesaProjeto.vue?vue&type=script&lang=js"
export * from "./ModalVisualizarDespesaProjeto.vue?vue&type=script&lang=js"

import "./ModalVisualizarDespesaProjeto.vue?vue&type=style&index=0&id=05487fb2&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-05487fb2"]])

export default __exports__